/* ============
 * Product Group Transformer
 * ============
 *
 * The transformer for the product group.
 */

import Transformer from './transformer';

export default class ProductGroupTransformer extends Transformer {

  static fetch(productGroup) {
    return {
      id: productGroup.id,
      parentGroupId: productGroup.parent_group_id,
      name: productGroup.name,
      description: productGroup.description,
      productsCount: productGroup.products_count,
      exciseDutyId: productGroup.excise_group_id,
    };
  }

  static send(productGroup) {
    return {
      id: productGroup.id,
      name: productGroup.name,
      parent_group_id: productGroup.parentGroupId,
      description: productGroup.description,
      excise_group_id: productGroup.exciseDutyId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productGroup.js